module.exports = __webpack_public_path__ + "static/media/thumbnail-telepules-rekonstrukcio-kivitelezes.84e6ffd5.jpg";